
import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { EnterUserSer, getAllRoleIds } from "./Services/EnterUserSer";
import axios from "axios";
import JoditEditor from "jodit-react";


const EditUser = () => {
  const { id } = useParams();

  useEffect(() => {
    const scriptUrls = [
      'assets/js/jquery.min.js',
      'assets/js/bootstrap.bundle.min.js',
      'assets/js/moment.min.js',
      'assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
      'assets/vendor/overlay-scroll/custom-scrollbar.js',
      'assets/vendor/daterange/daterange.js',
      'assets/vendor/daterange/custom-daterange.js',
      'assets/vendor/jquery-ui/jquery-ui.min.js',
      'assets/vendor/jquery-ui/custom.js',

      'assets/vendor/datatables/dataTables.min.js',
      'assets/vendor/datatables/dataTables.bootstrap.min.js',
      'assets/vendor/datatables/custom/custom-datatables.js',
      'assets/js/custom.js'
    ];

    let isCancelled = false;

    // Load scripts sequentially
    const loadScriptsSequentially = async () => {
      for (const url of scriptUrls) {
        if (isCancelled) break;

        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.onload = resolve;
          script.onerror = reject;
          document.body.appendChild(script);
        });
      }
    };

    loadScriptsSequentially();

    return () => {
      isCancelled = true;
      // Optionally remove scripts if needed
    };
  }, []);

  const navigate = useNavigate(); // For navigation
  const fileInputRef = useRef(null);

  const editor = useRef(null);
  const [content, setContent] = useState('')

  const [photo, setPhoto] = useState(null);
  // State variables for user details

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [passwords, setPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [alternativePhone, setAlternativePhone] = useState('');
  const [address, setAddress] = useState('');
  const [gender, setGender] = useState(null);
  const [dob, setDob] = useState('');
  const [age, setAge] = useState('');
  const [roleIds, setRoleIds] = useState([]);
  const [role, setRole] = useState('');
  const [userTypes, setUserTypes] = useState([]);
  const [selectedUserTypeId, setSelectedUserTypeId] = useState("");
  const [department, setDepartment] = useState([]);
  const [depName, setDepName] = useState('');
  const [maritalStatus, setMaritalStatus] = useState('');
  const [bloodGroup, setBloodGroup] = useState('');
  const [designations, setDesignations] = useState([]);
  const [designation, setDesignation] = useState('');
  const [qualification, setQualification] = useState('');

  const [selectedDesignationId, setSelectedDesignationId] = useState("");

  console.log(dob)


  const handleUpdateUser = (e) => {
    e.preventDefault();
    const formatDateForInput = (dateString) => {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`; // dd/MM/yyyy
    };
    const updatedUser = {
      firstName,
      lastName,
      email,
      phone,
      alternativePhone,
      address,
      gender,
      dob: formatDateForInput(dob), // Format the date for input
      qualification,
      age,
      rolesId: [role],
      userType: { id: selectedUserTypeId },
      designation: { id: selectedDesignationId },
      department: { id: depName }, // assuming depName is department ID
      maritalStatus,
      bloodGroup,
      password: passwords,

    };
    // updatedUser.password = passwords;
    console.log("Updated password:", passwords);
    console.log(updatedUser);
    console.log(updatedUser)

    axios
      .put(`http://localhost:8080/webnet-hms/api/users/${userId}`, updatedUser)
      .then((response) => {
        console.log("User updated successfully:", response.data);
        // Optionally show success toast or redirect
      })
      .catch((error) => {
        console.error("Error updating user data", error);
      });
  };


  const navigator = useNavigate();
  useEffect(() => {
    getAllRoleIds()
      .then((res) => {
        console.log("Fetched role IDs:", res.data);
        setRoleIds(res.data);
      })
      .catch((err) => {
        console.error("Error fetching role IDs:", err);
      });
  }, []);
  const handleEnter = (e) => {
    e.preventDefault();

    // Prepare the data as a JSON object
    const userData = {
      firstName: firstName,
      lastName: lastName,
      email: email,
      password: passwords,

      phone: phone,
      address: address,
      gender: gender,
      dob: dob,

      rolesId: parseInt(role),
      alternativePhone: alternativePhone,
      address: address,

    };

    // Use EnterUserSer to send the data to the backend
    EnterUserSer(userData)
      .then((response) => {
        console.log("User created successfully:", response.data);
        alert("User Created Succesfully :");
        navigator("/admin-view"); // Redirect to user list on success
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error creating user:", error);

        alert("Error creating user" + " userType :" + userTypes);

      });
  };
  const toSentenceCase = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const fetchUserTypes = () => {
    axios
      .get("http://localhost:8080/webnet-hms/api/user-types")
      .then((response) => {
        setUserTypes(response.data);
      })
      .catch((error) => {
        console.error("Error fetching user types:", error);
      });
  };

  const fetchDepartment = () => {
    axios
      .get("http://localhost:8080/webnet-hms/api/department")
      .then((response) => {
        setDepartment(response.data);
      })
      .catch((error) => {
        console.error("Error fetching user types:", error);
      });
  };
  const fetchDesignations = () => {
    axios.get("http://localhost:8080/webnet-hms/api/designation")
      .then((response) => {
        setDesignations(response.data);
      })
      .catch((error) => {
        console.error("Error fetching designations:", error);
      });
  };

  useEffect(() => {
    fetchUserTypes();
    fetchDepartment();
    fetchDesignations();
  }, []);
  const location = useLocation();
  const userId = location.state?.uata;

  const [userData, setUserData] = useState(null);
  console.log("Location state:", location.state);
  console.log("Fetched userId from location:", userId);
  useEffect(() => {
    axios.get(`http://localhost:8080/webnet-hms/api/users/${userId}`)
      .then((response) => {
        const formatDateForInput = (dateString) => {
          const date = new Date(dateString);
          return date.toISOString().split('T')[0]; // Ensures yyyy-MM-dd
        };
        const data = response.data;
        console.log(data);
        console.log(data.departmentName);
        setFirstName(data.firstName);
        setLastName(data.lastName);
        setEmail(data.email);
        setPhone(data.phone);
        setAlternativePhone(data.alternativePhone);
        setAddress(data.address);
        setDob(formatDateForInput(data.dob));
        setRole(data.rolesId); // assuming it's an array
        setSelectedUserTypeId(data.userType?.id);
        setSelectedDesignationId(data.designationId);
        setDepName(data.departmentId);
        setAddress(data.address);
        setMaritalStatus(data.maritalStatus);
        setBloodGroup(data.bloodGroup);
        setQualification(data.qualification);
        setAge(data.age);
        setGender(data.gender);
        setPassword(data.password);
        console.log("Fetched user data department:", data.departmentId);
        console.log("Fetched user data role:", data.rolesId);
        console.log("Fetched user data:", data.userTypeName);
      })
      .catch((error) => {
        console.error("Error fetching user data", error);
      });
  }, [userId]);

  const handleProfileSubmit = async () => {
    if (!photo) {
      alert("Please select a photo!");
      return;
    }

    const formData = new FormData();
    formData.append("userId", userId); // Replace with logged-in user ID
    formData.append("bio", content);
    formData.append("photo", photo);

    try {
      await axios.put(`http://localhost:8080/webnet-hms/api/profile/${userId}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Profile saved!");
    } catch (error) {
      console.error("Upload error:", error);
      alert("Failed to save profile.");
    }
  };

  const handlePhotoChange = (e) => {
    setPhoto(e.target.files[0]);
  };



  return (
    <div>
      {/* App hero header starts */}
      <div className="app-hero-header d-flex align-items-center">
        {/* Breadcrumb starts */}
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="index-2.html">
              <i className="ri-home-3-line" />
            </a>
          </li>
          <li className="breadcrumb-item text-primary" aria-current="page">
            Edit Admin User
          </li>
        </ol>
        {/* Breadcrumb ends */}
        {/* Sales stats starts */}
        <div className="ms-auto d-lg-flex d-none flex-row">
          <div className="input-group">
            <span className="input-group-text bg-primary-lighten">
              <i className="ri-calendar-2-line text-primary" />
            </span>
            <input type="text" id="abc" className="form-control custom-daterange" />
          </div>
        </div>
        {/* Sales stats ends */}
      </div>
      {/* App Hero header ends */}
      {/* App body starts */}
      <div className="app-body">
        {/* Row starts */}
        <div className="row gx-4">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                {/* Custom tabs starts */}
                <div className="custom-tabs-container">
                  {/* Nav tabs starts */}
                  <ul className="nav nav-tabs" id="customTab2" role="tablist">
                    <li className="nav-item" role="presentation">
                      <a className="nav-link active" id="tab-oneA" data-bs-toggle="tab" href="#oneA" role="tab" aria-controls="oneA" aria-selected="true"><i className="ri-briefcase-4-line" /> Personal
                        Details</a>
                    </li>
                    <li className="nav-item" role="presentation">
                      <a className="nav-link" id="tab-twoA" data-bs-toggle="tab" href="#twoA" role="tab" aria-controls="twoA" aria-selected="false"><i className="ri-account-pin-circle-line" />
                        Profile and Bio</a>
                    </li>
                    <li className="nav-item" role="presentation">
                      <a className="nav-link" id="tab-threeA" data-bs-toggle="tab" href="#threeA" role="tab" aria-controls="threeA" aria-selected="false"><i className="ri-calendar-check-line" />
                        Availability</a>
                    </li>
                    <li className="nav-item" role="presentation">
                      <a className="nav-link" id="tab-fourA" data-bs-toggle="tab" href="#fourA" role="tab" aria-controls="fourA" aria-selected="false"><i className="ri-lock-password-line" /> Account
                        Details</a>
                    </li>
                    <li className="nav-item" role="presentation">
                      <a className="nav-link" id="tab-fiveA" data-bs-toggle="tab" href="#fiveA" role="tab" aria-controls="fiveA" aria-selected="false"><i className="ri-lock-password-line" />
                        Permissions</a>
                    </li>
                  </ul>
                  {/* Nav tabs ends */}
                  {/* Tab content starts */}
                  <div className="tab-content">
                    <div className="tab-pane fade show active" id="oneA" role="tabpanel">
                      {/* Row starts */}
                      <div className="row gx-4">
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="a1">First Name <span className="text-danger">*</span></label>
                            <div className="input-group">
                              <span className="input-group-text">
                                <i className="ri-account-circle-line" />
                              </span>

                              <input type="text" className="form-control" id="a1" value={firstName}
                                onChange={(e) => setFirstName(e.target.value)} />

                            </div>
                          </div>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="a2">Last Name <span className="text-danger">*</span></label>
                            <div className="input-group">
                              <span className="input-group-text">
                                <i className="ri-account-circle-line" />
                              </span>

                              <input type="text" className="form-control" id="a2" value={lastName} onChange={e => setLastName(e.target.value)} />
                            </div>
                          </div>
                        </div>

                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="a4">Roles <span className="text-danger">*</span></label>
                            <i className="ri-secure-payment-line" />
                            <select
                              className="form-select"
                              id="a6"
                              required
                              value={role} // Use the 'role' state to hold the selected roleId
                              onChange={(e) => setRole(e.target.value)} // Update the 'role' state with the selected role ID
                            >
                              {roleIds.length > 0 ? (
                                roleIds.map((role) => (
                                  <option key={role.rolesId} value={role.rolesId}>
                                    {role.roleName} {/* Display the role name here */}
                                  </option>
                                ))
                              ) : (
                                <option value="">No roles available</option>
                              )}
                            </select>

                          </div>
                        </div>
                        <div className=" col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="a3">Age <span className="text-danger">*</span></label>
                            <div className="input-group">
                              <span className="input-group-text">
                                <i className="ri-flower-line" />
                              </span>

                              <select className="form-select" id="a3" onChange={(e) => setAge(e.target.value)}>
                                <option value="">{age}</option>
                                {Array.from({ length: 100 }, (_, i) => (
                                  <option key={i + 1} value={i + 1}>
                                    {i + 1}
                                  </option>
                                ))}

                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="selectGender1">Gender<span className="text-danger">*</span></label>
                            <div className="m-0">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="gender"
                                  value="male"
                                  checked={gender === 'MALE'}
                                  onChange={(e) => setGender(e.target.value)}
                                />
                                <label className="form-check-label">Male</label>
                              </div>

                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="gender"
                                  value="female"
                                  checked={gender === 'FEMALE'}
                                  onChange={(e) => setGender(e.target.value)}
                                />
                                <label className="form-check-label">Female</label>
                              </div>

                            </div>
                          </div>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="a4">Date of Birth <span className="text-danger">*</span></label>

                            <input
                              type="date"
                              className="form-control"
                              value={dob}
                              id="a4"
                              onChange={(e) => setDob(e.target.value)}
                              placeholder="Enter DOB"
                              name="dob"
                            />

                          </div>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="a6">Mobile Number <span className="text-danger">*</span></label>
                            <div className="input-group">
                              <span className="input-group-text">
                                <i className="ri-phone-line" />
                              </span>

                              <input type="text" className="form-control" id="a6" value={phone} onChange={e => setPhone(e.target.value)} />

                            </div>
                          </div>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="a6"> Alternate Mobile Number <span className="text-danger">*</span></label>
                            <div className="input-group">
                              <span className="input-group-text">
                                <i className="ri-phone-line" />
                              </span>

                              <input type="text" className="form-control" id="a6" value={alternativePhone}
                                onChange={(e) => setAlternativePhone(e.target.value)} />

                            </div>
                          </div>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="a5">Email ID <span className="text-danger">*</span></label>
                            <div className="input-group">
                              <span className="input-group-text">
                                <i className="ri-mail-open-line" />
                              </span>

                              <input type="email" className="form-control" id="a5" value={email} onChange={e => setEmail(e.target.value)} />

                            </div>
                          </div>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="a8">Qualification</label>
                            <div className="input-group">
                              <span className="input-group-text">
                                <i className="ri-copper-diamond-line" />
                              </span>
                              <select className="form-select" id="a8" value={qualification} onChange={e => setQualification(e.target.value)}>
                                <option value={qualification}>{qualification}</option>

                                <option value={0}>MSc.</option>
                                <option value={1}>BSc.</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="a10">Blood Group<span className="text-danger">*</span></label>
                            <div className="input-group">
                              <span className="input-group-text">
                                <i className="ri-drop-line" />
                              </span>
                              <select className="form-select" id="a10">

                                <option value={0}>{bloodGroup}</option>

                                <option value={1}>A+</option>
                                <option value={2}>A-</option>
                                <option value={3}>B+</option>
                                <option value={4}>B-</option>
                                <option value={5}>O+</option>
                                <option value={6}>O-</option>
                                <option value={7}>AB+</option>
                                <option value={8}>AB-</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="a7">Marital Status</label>
                            <div className="input-group">
                              <span className="input-group-text">
                                <i className="ri-vip-crown-2-line" />
                              </span>
                              <select className="form-select" id="a7" value={maritalStatus} onChange={e => setMaritalStatus(e.target.value)}>
                                <option >MARRIED</option>
                                <option>UNMARRIED</option>


                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="a6">
                              User Type <span className="text-danger">*</span>
                            </label>

                            <div className="input-group">
                              <span className="input-group-text">
                                <i class="ri-shield-user-line"></i>
                              </span>

                              <select
                                className="form-select"
                                id="userType"
                                value={selectedUserTypeId}
                                onChange={(e) => setSelectedUserTypeId(e.target.value)}
                                required
                              >
                                <option value="">
                                  {userTypes.find(type => type.id === selectedUserTypeId)?.userTypeName || "Select User Type"}
                                </option>
                                {userTypes.map((type) => (
                                  <option key={type.id} value={type.id}>
                                    {type.userTypeName}

                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <label className="form-label" htmlFor="a1">Department</label>
                          <select
                            className="form-select"
                            id="a1"
                            onChange={(e) => setDepName(e.target.value)}
                            value={depName}
                          >
                            <option value="">{depName}</option>
                            {department.length > 0 ? (
                              department.map((dept) => (
                                <option key={dept.departmentId} value={dept.departmentId}>
                                  {dept.departmentName}
                                </option>
                              ))
                            ) : (
                              <option value="">No departments available</option>
                            )}
                          </select>


                        </div>


                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="a9">Designation</label>
                            <div className="input-group">
                              <span className="input-group-text">
                                <i className="ri-nft-line" />
                              </span>

                              <select
                                className="form-select"
                                id="designationSelect"
                                value={selectedDesignationId}
                                onChange={(e) => {
                                  setSelectedDesignationId(e.target.value);
                                }}
                              >
                                <option value="">
                                  {designations.find(d => d.designationId == selectedDesignationId)?.designation || "-- Select Designation --"}
                                </option>
                                {designations.map((des) => (
                                  <option key={des.designationId} value={des.designationId}>
                                    {des.designation}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-xxl-12 col-lg-12 col-sm-12">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="a11">Address</label>
                            <div className="input-group">
                              <span className="input-group-text">
                                <i className="ri-projector-line" />
                              </span>

                              <textarea className="form-control" id="a15" placeholder="Enter Address" rows={2} value={address} onChange={e => setAddress(e.target.value)} required />

                            </div>
                          </div>
                        </div>

                      </div>
                      {/* Row ends */}
                    </div>
                    <div className="tab-pane fade" id="twoA" role="tabpanel">
                      {/* Row starts */}

                      <div className="tab-pane fade show active" id="twoA" role="tabpanel">
                        {/* Row starts */}
                        <div className="row gx-4">

                          {/* Show Selected Image */}
                          <div className="col-sm-2">
                            <div className="mb-3">
                              <img
                                src={photo ? URL.createObjectURL(photo) : "assets/images/doctor3.png"}
                                className="img-fluid rounded-2"
                                alt="Profile Preview"
                              />
                            </div>
                          </div>

                          {/* Upload New Photo */}
                          <div className="col-sm-2">
                            <div id="dropzone" className="mb-3">
                              <form className="dropzone dz-clickable" id="demo-upload" onSubmit={(e) => e.preventDefault()}>
                                <div className="dz-message">
                                  <input
                                    type="file"
                                    accept="image/*"
                                    ref={fileInputRef}
                                    onChange={handlePhotoChange}
                                    style={{ display: "none" }}
                                  />
                                  <button
                                    type="button"
                                    className="dz-button btn btn-secondary"
                                    onClick={() => fileInputRef.current.click()}
                                  >
                                    Upload new photo
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>

                          {/* Bio Editor */}
                          <div className="col-sm-12">
                            <JoditEditor
                              ref={editor}
                              value={content}
                              onChange={newContent => setContent(newContent)}
                            />
                          </div>

                          {/* Submit Button */}
                          <div className="col-sm-12 mt-3">
                            <button className="btn btn-primary" onClick={handleProfileSubmit}>
                              Save Profile
                            </button>
                          </div>

                        </div>
                      </div>
                      {/* Row ends */}
                    </div>
                    <div className="tab-pane fade" id="threeA" role="tabpanel">
                      {/* Row starts */}
                      <div className="row gx-4">
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="d1">Sunday</label>
                            <div className="input-group">
                              <select className="form-select" id="d2">
                                <option value={0}>9AM</option>
                                <option value={1}>5PM</option>
                                <option value={2}>1AM</option>
                              </select>
                              <select className="form-select" id="d2X">
                                <option value={0}>5PM</option>
                                <option value={1}>1AM</option>
                                <option value={2}>9AM</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="d2">Monday</label>
                            <div className="input-group">
                              <select className="form-select" id="d2">
                                <option value={0}>9AM</option>
                                <option value={1}>5PM</option>
                                <option value={2}>1AM</option>
                              </select>
                              <select className="form-select" id="d2X">
                                <option value={0}>5PM</option>
                                <option value={1}>1AM</option>
                                <option value={2}>9AM</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="d3">Tuesday</label>
                            <div className="input-group">
                              <select className="form-select" id="d2">
                                <option value={0}>9AM</option>
                                <option value={1}>5PM</option>
                                <option value={2}>1AM</option>
                              </select>
                              <select className="form-select" id="d2X">
                                <option value={0}>5PM</option>
                                <option value={1}>1AM</option>
                                <option value={2}>9AM</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="d4">Wednesday</label>
                            <div className="input-group">
                              <select className="form-select" id="d2">
                                <option value={0}>9AM</option>
                                <option value={1}>5PM</option>
                                <option value={2}>1AM</option>
                              </select>
                              <select className="form-select" id="d2X">
                                <option value={0}>5PM</option>
                                <option value={1}>1AM</option>
                                <option value={2}>9AM</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="d5">Thursday</label>
                            <div className="input-group">
                              <select className="form-select" id="d2">
                                <option value={0}>9AM</option>
                                <option value={1}>5PM</option>
                                <option value={2}>1AM</option>
                              </select>
                              <select className="form-select" id="d2X">
                                <option value={0}>5PM</option>
                                <option value={1}>1AM</option>
                                <option value={2}>9AM</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="d6">Friday</label>
                            <div className="input-group">
                              <select className="form-select" id="d2">
                                <option value={0}>9AM</option>
                                <option value={1}>5PM</option>
                                <option value={2}>1AM</option>
                              </select>
                              <select className="form-select" id="d2X">
                                <option value={0}>5PM</option>
                                <option value={1}>1AM</option>
                                <option value={2}>9AM</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="d7">Saturday</label>
                            <div className="input-group">
                              <select className="form-select" id="d2">
                                <option value={0}>9AM</option>
                                <option value={1}>5PM</option>
                                <option value={2}>1AM</option>
                              </select>
                              <select className="form-select" id="d2X">
                                <option value={0}>5PM</option>
                                <option value={1}>1AM</option>
                                <option value={2}>9AM</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Row ends */}
                    </div>
                    <div className="tab-pane fade" id="fourA" role="tabpanel">
                      {/* Row starts */}
                      <div className="row gx-4 justify-content-center">
                        <div className="col-sm-4">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="u1">User Name</label>
                            <div className="input-group">
                              <span className="input-group-text">
                                <i className="ri-account-pin-circle-line" />
                              </span>
                              <input type="text" id="u1" defaultValue="apollo99" className="form-control" />
                            </div>
                          </div>
                          <div className="mb-3">
                            <label className="form-label" htmlFor="u2">New Password</label>
                            <div className="input-group">
                              <span className="input-group-text">
                                <i className="ri-lock-password-line" />
                              </span>
                              <input type="password" id="u2" className="form-control" defaultValue="***********#9" />
                              <button className="btn btn-outline-secondary" type="button">
                                <i className="ri-eye-line" />
                              </button>
                            </div>
                          </div>
                          <div className="mb-3">
                            <label className="form-label" htmlFor="u3">Confirm New Password</label>
                            <div className="input-group">
                              <span className="input-group-text">
                                <i className="ri-lock-password-line" />
                              </span>
                              <input type="password" id="u3" defaultValue="***********#9" className="form-control" />
                              <button className="btn btn-outline-secondary" type="button">
                                <i className="ri-eye-off-line" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Row ends */}
                    </div>
                    <div className="tab-pane fade" id="fiveA" role="tabpanel">
                      {/* Row starts */}
                      <div className="row gx-4 justify-content-center">
                        <div className="col-sm-8 col-12">
                          <div>
                            <h5>Module Access</h5>
                            <p>Defines working hours, available departments, offered services, staff structure, supported languages, and currency settings to tailor daily hospital operations efficiently.</p>
                          </div>
                          <div className="list-group w-auto mb-5">
                            <div className="list-group-item d-flex align-items-center gap-3 py-3">
                              <div className="icon-box sm bg-secondary rounded-3">
                                <i className="ri-phone-line text-dark fs-4" />
                              </div>
                              <div>
                                <h6>Appointments</h6>
                                <p className="m-0">
                                  You can update new appointment notifications here.
                                </p>
                              </div>
                              <div className="form-check form-switch m-0 ms-auto">
                                <input className="form-check-input" type="checkbox" role="switch" id="n1" defaultChecked />
                              </div>
                            </div>
                            <div className="list-group-item d-flex align-items-center gap-3 py-3">
                              <div className="icon-box sm bg-secondary rounded-3">
                                <i className="ri-mail-send-line text-dark fs-4" />
                              </div>
                              <div>
                                <h6>Prescriptions</h6>
                                <p className="m-0">
                                  You can give priscriptions.
                                </p>
                              </div>
                              <div className="form-check form-switch m-0 ms-auto">
                                <input className="form-check-input" type="checkbox" role="switch" id="n2" defaultChecked />
                              </div>
                            </div>

                            <div className="list-group-item d-flex align-items-center gap-3 py-3">
                              <div className="icon-box sm bg-secondary rounded-3">
                                <i className="ri-radio-2-line text-dark fs-4" />
                              </div>
                              <div>
                                <h6>Stocks &amp; inventory</h6>
                                <p className="m-0">
                                  You can manage stocks and inventories.
                                </p>
                              </div>
                              <div className="form-check form-switch m-0 ms-auto">
                                <input className="form-check-input" type="checkbox" role="switch" id="n4" />
                              </div>
                            </div>
                            <div className="list-group-item d-flex align-items-center gap-3 py-3">
                              <div className="icon-box sm bg-secondary rounded-3">
                                <i className="ri-macbook-line text-dark fs-4" />
                              </div>
                              <div>
                                <h6>OPD</h6>
                                <p className="m-0">
                                  Enable OPD editions facilities.
                                </p>
                              </div>
                              <div className="form-check form-switch m-0 ms-auto">
                                <input className="form-check-input" type="checkbox" role="switch" id="n5" />
                              </div>
                            </div>
                            <div className="list-group-item d-flex align-items-center gap-3 py-3">
                              <div className="icon-box sm bg-secondary rounded-3">
                                <i className="ri-mail-send-line text-dark fs-4" />
                              </div>
                              <div>
                                <h6>IPD</h6>
                                <p className="m-0">
                                  Enable IPD facilities.
                                </p>
                              </div>
                              <div className="form-check form-switch m-0 ms-auto">
                                <input className="form-check-input" type="checkbox" role="switch" id="n6" defaultChecked />
                              </div>
                            </div>
                            <div className="list-group-item d-flex align-items-center gap-3 py-3">
                              <div className="icon-box sm bg-secondary rounded-3">
                                <i className="ri-chat-1-line text-dark fs-4" />
                              </div>
                              <div>
                                <h6>Pathology</h6>
                                <p className="m-0">
                                  Enable pathologies sevices.
                                </p>
                              </div>
                              <div className="form-check form-switch m-0 ms-auto">
                                <input className="form-check-input" type="checkbox" role="switch" id="n7" defaultChecked />
                              </div>
                            </div>
                            <div className="list-group-item d-flex align-items-center gap-3 py-3">
                              <div className="icon-box sm bg-secondary rounded-3">
                                <i className="ri-emoji-sticker-line text-dark fs-4" />
                              </div>
                              <div>
                                <h6>Blood Bank</h6>
                                <p className="m-0">
                                  Enable blood bank services.
                                </p>
                              </div>
                              <div className="form-check form-switch m-0 ms-auto">
                                <input className="form-check-input" type="checkbox" role="switch" id="n8" defaultChecked />
                              </div>
                            </div>
                            <div className="list-group-item d-flex align-items-center gap-3 py-3">
                              <div className="icon-box sm bg-secondary rounded-3">
                                <i className="ri-emoji-sticker-line text-dark fs-4" />
                              </div>
                              <div>
                                <h6>Pharmacy</h6>
                                <p className="m-0">
                                  Enable pharmacy services.
                                </p>
                              </div>
                              <div className="form-check form-switch m-0 ms-auto">
                                <input className="form-check-input" type="checkbox" role="switch" id="n8" defaultChecked />
                              </div>
                            </div>

                          </div>
                        </div>
                        <div className="col-sm-12 col-12">
                          <div>
                            <h5>Module Permissions</h5>
                            <p>Defines working permissions like read write and etc.</p>
                          </div>
                          <div class="card-body">
                            <div class="table-outer">
                              <div class="table-responsive">
                                <table class="table truncate m-0">
                                  <thead>
                                    <tr>
                                      <th>#</th>
                                      <th>Module Permission</th>
                                      <th>Read</th>
                                      <th>Write</th>
                                      <th>Create</th>
                                      <th>Delete</th>
                                      <th>Import</th>
                                      <th>Export</th>

                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>1</td>
                                      <td>Prescriptions</td>
                                      <td><div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                        <label class="form-check-label" for="inlineCheckbox1"></label>
                                      </div></td>
                                      <td><div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                        <label class="form-check-label" for="inlineCheckbox1"></label>
                                      </div></td>
                                      <td>
                                        <div class="form-check form-check-inline">
                                          <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                          <label class="form-check-label" for="inlineCheckbox1"></label>
                                        </div>
                                      </td>
                                      <td><div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                        <label class="form-check-label" for="inlineCheckbox1"></label>
                                      </div></td>
                                      <td>
                                        <div class="form-check form-check-inline">
                                          <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                          <label class="form-check-label" for="inlineCheckbox1"></label>
                                        </div>
                                      </td>
                                      <td><div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                        <label class="form-check-label" for="inlineCheckbox1"></label>
                                      </div></td>

                                    </tr>
                                    <tr>
                                      <td>2</td>
                                      <td>Appointments</td>
                                      <td><div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                        <label class="form-check-label" for="inlineCheckbox1"></label>
                                      </div></td>
                                      <td><div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                        <label class="form-check-label" for="inlineCheckbox1"></label>
                                      </div></td>
                                      <td>
                                        <div class="form-check form-check-inline">
                                          <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                          <label class="form-check-label" for="inlineCheckbox1"></label>
                                        </div>
                                      </td>
                                      <td><div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                        <label class="form-check-label" for="inlineCheckbox1"></label>
                                      </div></td>
                                      <td>
                                        <div class="form-check form-check-inline">
                                          <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                          <label class="form-check-label" for="inlineCheckbox1"></label>
                                        </div>
                                      </td>
                                      <td><div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                        <label class="form-check-label" for="inlineCheckbox1"></label>
                                      </div></td>

                                    </tr>
                                    <tr>
                                      <td>3</td>
                                      <td>Lab Reports</td>
                                      <td><div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                        <label class="form-check-label" for="inlineCheckbox1"></label>
                                      </div></td>
                                      <td><div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                        <label class="form-check-label" for="inlineCheckbox1"></label>
                                      </div></td>
                                      <td>
                                        <div class="form-check form-check-inline">
                                          <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                          <label class="form-check-label" for="inlineCheckbox1"></label>
                                        </div>
                                      </td>
                                      <td><div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                        <label class="form-check-label" for="inlineCheckbox1"></label>
                                      </div></td>
                                      <td>
                                        <div class="form-check form-check-inline">
                                          <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                          <label class="form-check-label" for="inlineCheckbox1"></label>
                                        </div>
                                      </td>
                                      <td><div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                        <label class="form-check-label" for="inlineCheckbox1"></label>
                                      </div></td>

                                    </tr>
                                    <tr>
                                      <td>4</td>
                                      <td>User Roles</td>
                                      <td><div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                        <label class="form-check-label" for="inlineCheckbox1"></label>
                                      </div></td>
                                      <td><div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                        <label class="form-check-label" for="inlineCheckbox1"></label>
                                      </div></td>
                                      <td>
                                        <div class="form-check form-check-inline">
                                          <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                          <label class="form-check-label" for="inlineCheckbox1"></label>
                                        </div>
                                      </td>
                                      <td><div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                        <label class="form-check-label" for="inlineCheckbox1"></label>
                                      </div></td>
                                      <td>
                                        <div class="form-check form-check-inline">
                                          <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                          <label class="form-check-label" for="inlineCheckbox1"></label>
                                        </div>
                                      </td>
                                      <td><div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                        <label class="form-check-label" for="inlineCheckbox1"></label>
                                      </div></td>

                                    </tr>

                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Row ends */}
                    </div>
                  </div>
                  {/* Tab content ends */}
                </div>
                {/* Custom tabs ends */}
                {/* Card acrions starts */}
                <div className="d-flex gap-2 justify-content-end mt-4">

                  <buttuon className="btn btn-outline-secondary">
                    Cancel
                  </buttuon>
                  <button className="btn btn-primary" onClick={handleUpdateUser}>
                    Update Profile
                  </button>


                </div>
                {/* Card acrions ends */}
              </div>
            </div>
          </div>
        </div>
        {/* Row ends */}
      </div>
      {/* App body ends */}
    </div>

  );
};

export default EditUser;

